import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Box, Stack, Typography} from 'views/components';

import {translate, Translate} from 'views/module';

const AuthenticateUserDialog = (props) => {
  const {open, onClose, onSubmit, initialData, isLoading} = props;
  const [form, setForm] = React.useState(initialData);

  React.useEffect(() => {
    setForm(initialData);
  }, [initialData, open]);

  const handleChange = (field, value) => {
    setForm((prev) => ({...prev, [field]: value}));
  };

  const isFormValid = React.useCallback(() => {
    return form.email && form.firstName;
  }, [form]);

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle onClose={onClose}>
        <Translate
          expression='client.ClientDetail.Relationships.Contacts.Dialogs.Setup.Title'
          substitute={{
            channelType: translate('client.ClientDetail.Relationships.Contacts.ChannelTypes.Email'),
            channel: translate('client.ClientDetail.Relationships.Contacts.Channels.Authentication'),
          }}
        />
      </DialogTitle>
      <DialogContent>
        <Box>
          <Stack spacing={2}>
            <Box>
              <Typography variant="h6"></Typography>
            </Box>
            <TextField
              label={<Translate expression='client.ClientDetail.Relationships.Contacts.Email' />}
              value={form.email}
              onChange={(e) => handleChange('email', e)}
              fullWidth
            />
            <TextField
              label={<Translate expression='client.ClientDetail.Relationships.Contacts.Fields.FirstName' />}
              value={form.firstName}
              onChange={(e) => handleChange('firstName', e)}
              fullWidth
            />
            <TextField
              label={<Translate expression='client.ClientDetail.Relationships.Contacts.Fields.LastName' />}
              value={form.lastName}
              onChange={(e) => handleChange('lastName', e)}
              fullWidth
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="primary" variant="contained" onClick={() => onSubmit(form)} disabled={isLoading || !isFormValid()}>
          <Translate expression='client.ClientDetail.Relationships.Contacts.Dialogs.Setup.ConfirmButton' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AuthenticateUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialData: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  isLoading: PropTypes.bool,
};

export default AuthenticateUserDialog;
